import React from 'react';
import AdminPersonnelModal, {
  ModalFormSection,
  ModalFormGroup,
  ModalFooterActions
} from '../ui/AdminPersonnelModal';

const FORM_ID = 'ap-member-form';

const MemberFormModal = ({
  show,
  onHide,
  formData,
  onChange,
  onSubmit,
  editingMember,
  companies,
  agents
}) => {
  const isEdit = Boolean(editingMember);
  const isDependent = formData.type !== 'AGENT';

  return (
    <AdminPersonnelModal
      show={show}
      onHide={onHide}
      size="xl"
      icon="user"
      badge={isEdit ? 'Modification' : 'Nouveau'}
      title={isEdit ? "Modifier l'adhérent" : 'Ajouter un adhérent'}
      subtitle="Titulaire ou ayant-droit rattaché à une société"
      ariaLabelledBy="ap-member-form-title"
      footer={
        <ModalFooterActions
          onCancel={onHide}
          primary={
            <button type="submit" form={FORM_ID} className="ap-modal-btn ap-modal-btn--primary">
              {isEdit ? 'Enregistrer' : "Créer l'adhérent"}
            </button>
          }
        />
      }
    >
      <form id={FORM_ID} className="ap-modal-form" onSubmit={onSubmit}>
        <ModalFormSection title="Identité">
          <div className="ap-modal-form__grid">
            <ModalFormGroup label="Matricule" required htmlFor="mem-matricule">
              <input
                id="mem-matricule"
                type="text"
                name="matricule"
                className="ap-modal-input"
                value={formData.matricule}
                onChange={onChange}
                placeholder="Matricule"
                required
                autoFocus
              />
            </ModalFormGroup>
            <ModalFormGroup label="Société" required htmlFor="mem-company">
              <select
                id="mem-company"
                name="company_id"
                className="ap-modal-select"
                value={formData.company_id}
                onChange={onChange}
                required
              >
                <option value="">— Sélectionner —</option>
                {companies.map((company) => (
                  <option key={company.id} value={company.id}>
                    {company.name}
                  </option>
                ))}
              </select>
            </ModalFormGroup>
            <ModalFormGroup label="Nom" required htmlFor="mem-nom">
              <input
                id="mem-nom"
                type="text"
                name="nom"
                className="ap-modal-input"
                value={formData.nom}
                onChange={onChange}
                placeholder="Nom"
                required
              />
            </ModalFormGroup>
            <ModalFormGroup label="Prénom" required htmlFor="mem-prenom">
              <input
                id="mem-prenom"
                type="text"
                name="prenom"
                className="ap-modal-input"
                value={formData.prenom}
                onChange={onChange}
                placeholder="Prénom"
                required
              />
            </ModalFormGroup>
            <ModalFormGroup label="Sexe" htmlFor="mem-sexe">
              <select
                id="mem-sexe"
                name="sexe"
                className="ap-modal-select"
                value={formData.sexe}
                onChange={onChange}
              >
                <option value="">— Non renseigné —</option>
                <option value="M">Masculin</option>
                <option value="F">Féminin</option>
              </select>
            </ModalFormGroup>
            <ModalFormGroup label="Fonction" htmlFor="mem-fonction">
              <input
                id="mem-fonction"
                type="text"
                name="fonction"
                className="ap-modal-input"
                value={formData.fonction}
                onChange={onChange}
                placeholder="Poste / fonction"
              />
            </ModalFormGroup>
          </div>
        </ModalFormSection>

        <ModalFormSection
          title="Rattachement"
          hint={isDependent ? "L'agent titulaire est obligatoire pour un ayant-droit" : 'Titulaire (agent) de la couverture'}
        >
          <div className="ap-modal-form__grid">
            <ModalFormGroup label="Type" required htmlFor="mem-type">
              <select
                id="mem-type"
                name="type"
                className="ap-modal-select"
                value={formData.type}
                onChange={onChange}
                required
              >
                <option value="AGENT">Agent (titulaire)</option>
                <option value="CONJOINT">Conjoint</option>
                <option value="CONJOINTE">Conjointe</option>
                <option value="ENFANT">Enfant</option>
              </select>
            </ModalFormGroup>
            {isDependent ? (
              <ModalFormGroup label="Agent titulaire" required htmlFor="mem-agent">
                <select
                  id="mem-agent"
                  name="agent_id"
                  className="ap-modal-select"
                  value={formData.agent_id}
                  onChange={onChange}
                  required
                >
                  <option value="">— Sélectionner un agent —</option>
                  {agents.map((agent) => (
                    <option key={agent.id} value={agent.id}>
                      {agent.matricule} — {agent.nom} {agent.prenom}
                    </option>
                  ))}
                </select>
              </ModalFormGroup>
            ) : null}
          </div>
        </ModalFormSection>

        <ModalFormSection title="Dates">
          <div className="ap-modal-form__grid">
            <ModalFormGroup label="Date de naissance" htmlFor="mem-naissance">
              <input
                id="mem-naissance"
                type="date"
                name="date_naissance"
                className="ap-modal-input"
                value={formData.date_naissance}
                onChange={onChange}
              />
            </ModalFormGroup>
            <ModalFormGroup label="Date d'embauche" htmlFor="mem-embauche">
              <input
                id="mem-embauche"
                type="date"
                name="date_embauche"
                className="ap-modal-input"
                value={formData.date_embauche}
                onChange={onChange}
              />
            </ModalFormGroup>
          </div>
        </ModalFormSection>
      </form>
    </AdminPersonnelModal>
  );
};

export default MemberFormModal;
